import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IAidasUser } from 'app/shared/model/ainnotateservice/aidas-user.model';
import { getEntities as getAidasUsers } from 'app/entities/ainnotateservice/aidas-user/aidas-user.reducer';
import { IAidasObject } from 'app/shared/model/ainnotateservice/aidas-object.model';
import { getEntities as getAidasObjects } from 'app/entities/ainnotateservice/aidas-object/aidas-object.reducer';
import { getEntity, updateEntity, createEntity, reset } from './aidas-user-aidas-object-mapping.reducer';
import { IAidasUserAidasObjectMapping } from 'app/shared/model/ainnotateservice/aidas-user-aidas-object-mapping.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasUserAidasObjectMappingUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const aidasUsers = useAppSelector(state => state.aidasUser.entities);
  const aidasObjects = useAppSelector(state => state.aidasObject.entities);
  const aidasUserAidasObjectMappingEntity = useAppSelector(state => state.aidasUserAidasObjectMapping.entity);
  const loading = useAppSelector(state => state.aidasUserAidasObjectMapping.loading);
  const updating = useAppSelector(state => state.aidasUserAidasObjectMapping.updating);
  const updateSuccess = useAppSelector(state => state.aidasUserAidasObjectMapping.updateSuccess);

  const handleClose = () => {
    props.history.push('/aidas-user-aidas-object-mapping' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getAidasUsers({}));
    dispatch(getAidasObjects({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.dateAssigned = convertDateTimeToServer(values.dateAssigned);

    const entity = {
      ...aidasUserAidasObjectMappingEntity,
      ...values,
      aidasUser: aidasUsers.find(it => it.id.toString() === values.aidasUserId.toString()),
      aidasObject: aidasObjects.find(it => it.id.toString() === values.aidasObjectId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          dateAssigned: displayDefaultDateTime(),
        }
      : {
          ...aidasUserAidasObjectMappingEntity,
          dateAssigned: convertDateTimeFromServer(aidasUserAidasObjectMappingEntity.dateAssigned),
          aidasUserId: aidasUserAidasObjectMappingEntity?.aidasUser?.id,
          aidasObjectId: aidasUserAidasObjectMappingEntity?.aidasObject?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="ainnotategwApp.ainnotateserviceAidasUserAidasObjectMapping.home.createOrEditLabel"
            data-cy="AidasUserAidasObjectMappingCreateUpdateHeading"
          >
            Create or edit a AidasUserAidasObjectMapping
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="aidas-user-aidas-object-mapping-id"
                  label="ID"
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label="Date Assigned"
                id="aidas-user-aidas-object-mapping-dateAssigned"
                name="dateAssigned"
                data-cy="dateAssigned"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label="Status"
                id="aidas-user-aidas-object-mapping-status"
                name="status"
                data-cy="status"
                check
                type="checkbox"
              />
              <ValidatedField
                id="aidas-user-aidas-object-mapping-aidasUser"
                name="aidasUserId"
                data-cy="aidasUser"
                label="Aidas User"
                type="select"
                required
              >
                <option value="" key="0" />
                {aidasUsers
                  ? aidasUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.firstName}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>This field is required.</FormText>
              <ValidatedField
                id="aidas-user-aidas-object-mapping-aidasObject"
                name="aidasObjectId"
                data-cy="aidasObject"
                label="Aidas Object"
                type="select"
                required
              >
                <option value="" key="0" />
                {aidasObjects
                  ? aidasObjects.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>This field is required.</FormText>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/aidas-user-aidas-object-mapping"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AidasUserAidasObjectMappingUpdate;
